import { useState, useEffect } from 'react'
import '../inquiry/telephonic/telephonic.scss'
import { useDispatch, useSelector } from 'react-redux'
import Button from '../../components/button/Button'
import { useNavigate } from 'react-router-dom'
import { numbers, permissions, ROUTES_PATH, UI_CONSTANT } from '../../utility/constants'
import PageDropdown from '../../components/page-dropdown/PageDropdown'
import { FilterMatchMode, FilterService } from 'primereact/api'
import ParentDataTable from '../../components/data-table/ParentDataTable'
import '../course/viewCourseList.scss'
import BreadCrumbs from '../../components/breadcrumb/Breadcrumb'
import { Box, Typography } from '@mui/material'
import RightDrawer from '../../components/drawer/Drawer'
import * as Yup from 'yup'
import { ErrorMessage, Formik } from 'formik'
import NewInput from '../../components/input/NewInput'
import closeIcon from '../../assets/icons/close.svg'
import { Dropdown } from 'primereact/dropdown'
import PopupBox from '../../components/popup/PopupBox'
import HorizontalLine from '../../assets/icons/Line33.svg'
import ModalUnstyled from '../../components/model/Model'
import {
  capitalizeFirstLetter,
  dynamicCustomFilter,
  handleInput,
  handleInventory,
} from '../../utility/genricFunction'
import {
  getInventoryHistory,
  mangeInventory,
} from '../../store/builders/inventory/inventory.builder'
import pencilIcon from '../../assets/icons/pencil1.svg'
import { VALIDATION_MESSAGES } from '../../utility/constantValidationMessages'
import UseAuthorization from '../../utility/useAuthorization'
import { createInquirySource, editInquirySource, getAllInquirySources } from '../../store/builders/inquirySource/inquirySource.builder'
import Loader from '../../components/loader/Loader'

const InquirySourceList = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [isOpen, setIsOpen] = useState(false)
  const { loading, inquirySourceData } = useSelector((state) => state.inquirySource)
  const [archiveId, setArchiveId] = useState('')
  const [singleInventoryData, setSingleInventoryData] = useState('')

  const branchList = useSelector((store) => store.branch.branchTableData)

  const branches = branchList.map((branch) => {
    return { label: branch.branchName, value: branch.branchId }
  })

  const handleBranchDropdownChange = (value, setFieldValue) => {
    setFieldValue('branchName', value)
  }

  useEffect(() => {
    dispatch(getAllInquirySources())
    return () => dispatch({ type: 'inquirySource/clearExtraReducers' })
  }, [])

  const numbers = [
    { label: '10', value: 10 },
    { label: '25', value: 25 },
    { label: '50', value: 50 },
  ]
  const [selectedNumber, setSelectedNumber] = useState(numbers[0].value)

  FilterService.register('dynamic_custom', (value, filter, filterMeta) => {
    return dynamicCustomFilter(value, filter, filterMeta?.matchMode || 'CONTAINS')
  })

  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    inquirySourceName: { value: null, matchMode: 'dynamic_custom' },
    inquirySourceStatus: { value: null, matchMode: FilterMatchMode.EQUALS },
    verified: { value: null, matchMode: FilterMatchMode.EQUALS },
  })

  const [open, setOpen] = useState(false)
  const [inventoryDrawerOpen, setInventoryDrawerOpen] = useState(false)
  const [editInventoryDrawer, setEditInventoryDrawer] = useState(false)
  const [filteredData, setFilteredData] = useState([])
  const [filterNumber] = useState(false)

  const [selectedValue, setSelectedValue] = useState(null)
  const statuses = [
    { label: 'active', value: 'active' },
    { label: 'inactive', value: 'inactive' },
  ]

  useEffect(() => {
    setFilteredData(inquirySourceData)
  }, [inquirySourceData])

  const onFilter = (event) => {
    const newFilters = { ...filters, ...event.filters }
    setFilters(newFilters)
    const filtered = filterData(inquirySourceData, newFilters)
    setFilteredData(filtered)
  }

  const filterData = (data, filters) => {
    return data.filter((item) => {
      return Object.keys(filters).every((key) => {
        if (!filters[key].value) return true
        const value = item[key]
        const filterValue = filters[key].value.toLowerCase().trim()
        return value && value.toString().toLowerCase().includes(filterValue)
      })
    })
  }

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen)
  }

  const toggleDrawerForAddInventory = (newOpen, inquirySourceData) => () => {
    setInventoryDrawerOpen(newOpen)
    setIsOpen(true)
    setSingleInventoryData(inquirySourceData)
  }

  const toggleDrawerForEditInventory = (newOpen, inquirySourceData) => () => {
    setEditInventoryDrawer(newOpen)
    setIsOpen(true)
    setSingleInventoryData(inquirySourceData)

  }

  const validationSchema = Yup.object().shape({
    inquirySourceName: Yup.string().required(VALIDATION_MESSAGES.INQUIRY_SOURCE),
  })

  const DrawerList = (
    <Box className='timetable-drawer' role='presentation'>
      <Box className='timetable-drawer-header flex justify-between align-center'>
        <Typography className='timetable-drawer-title'>{UI_CONSTANT.INQUIRY_SOURCE.ADD_INQUIRY_SOURCE}</Typography>
        <img className='timetable-drawer-icon' src={closeIcon} alt='Close' onClick={toggleDrawer(false)} />
      </Box>
      <Box className='drawer-horizontal-line' />

      <Formik
        initialValues={{
          quantity: '',
          inquirySourceName: '',
        }}
        validationSchema={validationSchema}
        onSubmit={(value) => {
          const data={
            setOpen,
            value
          }
          dispatch(createInquirySource(data))
        }}
      >
        {({  handleSubmit, errors }) => (
          <form>
            <div className='full-form'>
              <div className='first-row'>
                <NewInput
                  label='Inquiry Source Name'
                  placeholder='Enter Inquiry Source Name'
                  name='inquirySourceName'
                  width={'50%'}
                  required={true}
                  onInput={handleInventory}
                />
              </div>
            </div>

            <div className='right-drawer-save'>
              <Button customClassName={'drawer-save-btn'} onClick={handleSubmit}>
                {UI_CONSTANT.SUBMIT}
              </Button>
            </div>
          </form>
        )}
      </Formik>
    </Box>
  )

  const handleManageInventoryFormSubmit = (value) => {
    const data = {
      value,
      setInventoryDrawerOpen
    }
    dispatch(mangeInventory(data))
  }

  const InquirySourceDrawerList = (data) => {
    const manageInventoryValidationSchema = Yup.object().shape({
      branchName: Yup.string().required('Branch Name is required'),
      branchMaterialQuantity: Yup.number()
        .required('Quantity is required')
        .max(data?.data?.quantity, `Quantity should not be greater than ${data?.data?.quantity}`),
    })

    return (
      <Box className='timetable-drawer' role='presentation'>
        <Box className='timetable-drawer-header flex justify-between align-center'>
          <Typography className='timetable-drawer-title'>Manage Inventory</Typography>
          <img
            className='timetable-drawer-icon'
            src={closeIcon}
            alt='Close'
            onClick={toggleDrawerForAddInventory(false)}
          />
        </Box>
        <Box className='drawer-horizontal-line' />

        <Formik
          initialValues={{
            branchMaterialQuantity: '',
            materialId: data?.data?.materialId,
            branchName: '',
          }}
          validationSchema={manageInventoryValidationSchema}
          onSubmit={(value) => {
            handleManageInventoryFormSubmit(value)
          }}
        >
          {({ values, handleSubmit, setFieldValue }) => (
            <form>
              <div className='full-form'>
                <div className='first-row'>
                  <NewInput
                    label='Inventory Quantity'
                    placeholder='Enter inventory quantity'
                    name='branchMaterialQuantity'
                    width={'50%'}
                    type={'number'}
                    required={true}
                    onInput={handleInput}
                  />

                  <div className='first-field w-50'>
                    <label className='branch-title-inp padding-top-0' htmlFor=''>
                      Branch
                      <span className='required-symbol'>*</span>
                    </label>
                    <PageDropdown
                      options={branches}
                      selectedValue={values.branchName}
                      className={'branch-dropdown'}
                      onChange={(e) => handleBranchDropdownChange(e.target.value, setFieldValue)}
                      name={'branchName'}
                      placeholder={'Select branch'}
                    />
                    <ErrorMessage name='branchName' component='div' className='error-msg' />
                  </div>
                </div>
              </div>

              <div className='right-drawer-save'>
                <Button customClassName={'drawer-save-btn'} onClick={handleSubmit}>
                  {UI_CONSTANT.SUBMIT}
                </Button>
              </div>
            </form>
          )}
        </Formik>
      </Box>
    )
  }

  const handleEditInquirySourceFormSubmit = (value) => {
    const data = {
      value,
      setEditInventoryDrawer
    }
    dispatch(editInquirySource(data))
  }

  const EditInquirySourceDrawerList = (data) => {
    const editInventoryValidationSchema = Yup.object().shape({
      inquirySourceName: Yup.string().required('Quantity is required'),
    })

    return (
      <Box className='timetable-drawer' role='presentation'>
        <Box className='timetable-drawer-header flex justify-between align-center'>
          <Typography className='timetable-drawer-title'>{UI_CONSTANT.INVENTORY.EDIT_INVENTORY}</Typography>
          <img
            className='timetable-drawer-icon'
            src={closeIcon}
            alt='Close'
            onClick={toggleDrawerForEditInventory(false)}
          />
        </Box>
        <Box className='drawer-horizontal-line' />

        <Formik
          initialValues={{
            inquirySourceName: data?.data?.inquirySourceName,
            inquirySourceId: data?.data?.inquirySourceId,
            inquirySourceStatus: data?.data?.inquirySourceStatus,
          }}
          validationSchema={editInventoryValidationSchema}
          onSubmit={(value) => {
            handleEditInquirySourceFormSubmit(value)
          }}
        >
          {({ handleSubmit, values, handleChange }) => (
            <form>
              <div className='designation-field-wrapper flex justify-between'>
                <div className='designation-drawer-input'>
                  <div className='designation-drawer-input-label'>
                    <NewInput
                      value={values.inquirySourceName}
                      onInput={handleInventory}
                      label='Inquiry Source'
                      placeholder='Enter inquiry source'
                      name='inquirySourceName'
                      width={'100%'}
                      type={'text'}
                      required={true}
                    />
                  </div>
                </div>

                <div className='designation-drawer-input1'>
                  <label className='designation-drawer-input-label' htmlFor=''>
                    Inquiry Source Status <span className='required-symbol'>*</span>
                  </label>
                  <PageDropdown
                    options={statuses}
                    selectedValue={values.inquirySourceStatus}
                    className={'designation-drawer-option'}
                    onChange={handleChange}
                    name={'inquirySourceStatus'}
                    placeholder={'Select Inquiry Source Status'}
                  />
                  <ErrorMessage name='inquirySourceStatus' component='div' className='error-msg' />
                </div>
              </div>

              <div className='right-drawer-save'>
                <Button customClassName={'drawer-save-btn'} onClick={handleSubmit}>
                  {UI_CONSTANT.SUBMIT}
                </Button>
              </div>
            </form>
          )}
        </Formik>
      </Box>
    )
  }

  const nameBody = (inquirySourceTableData) => {
    const representative = inquirySourceTableData?.inquirySourceName && capitalizeFirstLetter(inquirySourceTableData?.inquirySourceName)
    return (
      <div className='flex align-items-center gap-2'>
        <span>{representative}</span>
      </div>
    )
  }
  const statusBody = (inquirySourceTableData) => {
    const representative = inquirySourceTableData?.inquirySourceStatus && capitalizeFirstLetter(inquirySourceTableData?.inquirySourceStatus)
    return (
      <div className='flex align-items-center gap-2'>
        <span>{representative}</span>
      </div>
    )
  }

  const statusRowFilterTemplate = (options) => {
    const onDropdownChange = (e) => {
      setSelectedValue(e.value)
      options.filterApplyCallback(e.value)
    }
    return (
      <Dropdown
        value={selectedValue}
        options={statuses}
        onChange={onDropdownChange}
        // itemTemplate={statusItemTemplate}
        placeholder='All'
        className='p-column-filter'
        optionLabel='label'
        showClear
      // style={{ minWidth: '12rem' }}
      />
    )
  }

  const verifiedBodyTemplate = (inquirySourceData) => {

    return (
      <>
        <PopupBox rowData={inquirySourceData} setIsOpen={setIsOpen} isOpen={isOpen}>
          <div className='popupbox'>
            <p className='verifiedBodyTemplate-Assign'>{UI_CONSTANT.POP_UP_ACTION}</p>

            <img src={HorizontalLine} alt='' />

            {UseAuthorization(permissions.EDIT_INVENTORY) && (
              <button className='div-assign-to-branch' onClick={toggleDrawerForEditInventory(true, inquirySourceData)}>
                <img src={pencilIcon} alt='' />
                <p className='verifiedBodyTemplate-darkfont'>Edit inquiry source</p>
              </button>
            )}

          </div>
        </PopupBox>
        <RightDrawer anchor='right' isOpen={inventoryDrawerOpen} onClose={toggleDrawerForAddInventory(false)}>
          <InquirySourceDrawerList data={singleInventoryData} />
        </RightDrawer>
      </>
    )
  }

  const columns = [
    {
      sortable: true,
      field: 'inquirySourceName',
      header: 'Inquiry Source',
      filter: true,
      filterDisplay: 'row',
      filterPlaceholder: 'Search by name...',
      style: { minWidth: '12rem' },
      body: nameBody,
    },
    {
      sortable: true,
      field: 'inquirySourceStatus',
      header: 'Status',
      showFilterMenu: false,
      filterMenuStyle: { minWidth: '5rem' },
      style: { minWidth: '10rem' },
      body: statusBody,
      filter: true,
      filterElement: statusRowFilterTemplate,
    },
    {
      sortable: false,
      field: 'verified',
      header: '',
      dataType: 'boolean',
      style: { maxWidth: '4rem' },
      body: verifiedBodyTemplate,
      filter: false,
    },
  ]

  const breadCrumbsArr = [
    {
      title: UI_CONSTANT.INQUIRY_SOURCE.LABEL_INQUIRY_SOURCE,
      link: null,
    },
    {
      title: UI_CONSTANT.DASHBOARD,
      link: ROUTES_PATH.DASHBOARD,
    },
    {
      title: UI_CONSTANT.INVENTORY.LABEL_INVENTORY,
      link: ROUTES_PATH.INVENTORY,
    },
  ]

  return (
    <>
      {/* <div className={`telephonic-container flex flex-column`}> */}

      {loading && <Loader loading={loading} />}

      {<Loader loading={loading} /> && <div className={`course-list }`}>
        <div className='filter-bar-wraper'>
          <div className='subheader'>
            <BreadCrumbs breadCrumbsArr={breadCrumbsArr} />
            {/* {userRole === 'admin' && UseAuthorization('ADD_INVENTORY') && ( */}
            {UseAuthorization(permissions.ADD_INVENTORY) && (
              <Button className='add-btn' onClick={toggleDrawer(true)}>
                {UI_CONSTANT.INQUIRY_SOURCE.ADD_INQUIRY_SOURCE}
              </Button>
            )}
          </div>
          <RightDrawer anchor='right' isOpen={open} onClose={toggleDrawer(false)}>
            {DrawerList}
          </RightDrawer>
        </div>

        <div className='group-parent'>
          <div className='frame-wrapper'>
            <div className='course-list-wrapper'>
              <b className='course-list1'>
                {UI_CONSTANT.INQUIRY_SOURCE.ALL_INQUIRY_SOURCE}
              </b>
            </div>
          </div>
          <div className='flex page-drop-div'>
            <p className='page-sidetext'>{UI_CONSTANT.TABLE_HEADER_SAW}</p>
            <PageDropdown
              options={numbers}
              selectedValue={selectedNumber}
              onChange={(e) => setSelectedNumber(e.value)}
              className='w-full md:w-14rem small-dropdown'
            />
            <p className='page-endtext'>{UI_CONSTANT.TABLE_HEADER_ENTRIES}</p>
          </div>

          <div id='inventory-list-table' className='table-card'>
            <ParentDataTable
              value={filteredData}
              rows={filterNumber ? filteredData.length : selectedNumber}
              filters={filters}
              // loading={loading}
              columns={columns}
              onFilter={onFilter}
            />
          </div>
        </div>
        {/* <9/div> */}
        {editInventoryDrawer && (
          <RightDrawer anchor='right' isOpen={editInventoryDrawer} onClose={toggleDrawerForEditInventory(false)}>
            <EditInquirySourceDrawerList data={singleInventoryData} />
          </RightDrawer>
        )}
      </div>}
    </>
  )
}

export default InquirySourceList
